import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '@/components/ui/button'
import Modal, { hideModal, showModal } from '../../widgets/modal'
import { actions } from '../Account/account.slice'
import { saveAccountUser, sendAccountPasswordResetLink } from '../Account/account.asyncActions'
import { selectSelectedRow } from '../Account/account.selector'
import { selectUser } from '../Profile/profile.selectors'
import { Loader2 } from 'lucide-react'

const { setAccountModal, setSelectedRow } = actions

const ResetModal = ({ setNotifyToggle }) => {
	const dispatch = useDispatch()
	const selectedRow = useSelector(selectSelectedRow)
	const currentUser = useSelector(selectUser)
	const [isSending, setIsSending] = useState(false)

	const { id, email, name, lastSignIn } = selectedRow
	const isInvite = !lastSignIn

	const resetModal = () => {
		dispatch(setAccountModal(null))
		dispatch(setSelectedRow({}))
	}

	useEffect(() => {
		dispatch(showModal())
	})

	const handleClose = () => {
		dispatch(hideModal())
		resetModal()
	}

	const handleSend = () => {
		setIsSending(true)

		const action = isInvite
			? saveAccountUser({
				id,
				name,
				email,
				shouldResendInvite: true,
				backOfficeUserId: currentUser.id,
			})
			: sendAccountPasswordResetLink({ id })

		dispatch(action).then(({ payload }) => {
			setIsSending(false)
			const isError = payload?.status && payload.status >= 400
			if (!isError && setNotifyToggle) {
				setNotifyToggle({
					show: true,
					message: isInvite
						? `Invitation sent to ${email || name}`
						: `Password reset link sent to ${email || name}`,
				})
			}
			dispatch(setAccountModal(null))
			dispatch(setSelectedRow({}))
		})
	}

	const footer = (
		<>
			<Button
				className='h-50 w-190 mr--10'
				variant='outline'
				onClick={handleClose}
			>
				Cancel
			</Button>
			<Button
				className='h-50 w-190'
				onClick={handleSend}
				disabled={isSending}
			>
				{isSending && <Loader2 className='mr-2 h-4 w-4 animate-spin' />}
				{isInvite ? 'Send Invitation' : 'Send Reset Link'}
			</Button>
		</>
	)

	return (
		<Modal
			footer={footer}
			reset={resetModal}
			title={isInvite ? 'Resend Invitation' : 'Reset User Password'}
			size='sm'
		>
			<div className='f-14' style={{ textAlign: 'center', padding: '16px 0' }}>
				<p style={{ marginBottom: '8px' }}>
					{isInvite
						? 'Resend the account setup invitation to:'
						: 'Send a password reset link to:'}
				</p>
				<p style={{ fontWeight: 600 }}>
					{name || email || id}
				</p>
				{email && (
					<p style={{ color: '#666', fontSize: '13px', marginTop: '4px' }}>
						{email}
					</p>
				)}
				<p style={{ color: '#666', fontSize: '13px', marginTop: '16px' }}>
					{isInvite
						? 'The user will receive a welcome email with a secure link to set their password.'
						: 'The user will receive an email with a secure link to set a new password.'}
				</p>
			</div>
		</Modal>
	)
}
export default ResetModal
